import { colors } from '../../styles'
import styled from 'styled-components'
import { Button } from '@material-ui/core'

export const StyledSearchFilters = styled.div`
  padding: 0 12px 0 24px;
`

export const StyledSwitcher = styled.div`
  border: 1px solid ${(props) => colors[props.theme]};
  border-radius: 5px;
  display: inline-block;
  margin: 16px 0;
  display: flex;
  & > * {
    flex: 1;
  }
` as any

export const StyledButton = styled(Button)`
  cursor: pointer;
  font-size: 14px;
  font-family: knowledge2017regular;
  box-shadow: none;
  border-radius: 0;
  text-transform: none;
  padding: 8px 0;
` as any
